import React from "react";
import { toast } from "react-hot-toast";

export default function UpdateToast({ t, onRefresh }) {
  return (
    <div
      style={{
        background: "#1f2937",
        color: "#fff",
        padding: "12px 16px",
        borderRadius: 8,
        boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
        display: "flex",
        alignItems: "center",
        gap: 12,
        minWidth: 320,
        maxWidth: 420,
      }}
    >
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, marginBottom: 2 }}>
          New version available
        </div>
        <div style={{ fontSize: 13, color: "#d1d5db" }}>
          Auto-refreshing when you're idle...
        </div>
      </div>
      <button
        type="button"
        onClick={() => {
          toast.dismiss(t.id);
          onRefresh();
        }}
        style={{
          background: "#3b82f6",
          color: "#fff",
          border: "none",
          padding: "8px 12px",
          borderRadius: 6,
          fontWeight: 600,
          cursor: "pointer",
          fontSize: 13,
        }}
      >
        Refresh now
      </button>
    </div>
  );
}
